import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { load } from "@amap/amap-jsapi-loader";
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { environment } from 'src/environments/environment';
declare var AMap: any;
@Component({
  selector: 'app-amap',
  templateUrl: './app-amap.component.html',
  styleUrls: ['./app-amap.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppAMapComponent),
      multi: true,
    }
  ]
})
export class AppAMapComponent implements OnInit {


  @Input() height: number=500;
  private map: any;
  private locationMarker;
  @Input() lnglat: Array<any>;
  constructor() { }
  ngOnInit(): void {
    load(environment.amap).then((AMap) => {
      this.map = new AMap.Map('map', {
        resizeEnable: true
      });
      AMap.plugin(['AMap.PlaceSearch', 'AMap.AutoComplete'], () => {
        var oppt = { input: "tipinput" };
        var auto = new AMap.AutoComplete(oppt);
        auto.on("select", (e) => this.select(e));//注册监听，当选中某条记录时会触发
      });
      this.map.on('click', (e) => this.mapClick(e));
      if(this.lnglat){
        this.mapClick({ lng: this.lnglat[0], lat: this.lnglat[1] });
      }
    }).catch(e => {
      console.log(e);
    })
  }
  propagateChange = (_: any) => { };
  writeValue(value: any): void {
    this.lnglat = value;
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {

  }
  setDisabledState?(isDisabled: boolean): void {

  }

  select(e) {
    this.mapClick({ lng: e.poi.location.lng, lat: e.poi.location.lat });
  }
  mapClick(e) {
    var lng = e.lng ?? e.lnglat.getLng();
    var lat = e.lat ?? e.lnglat.getLat();
    this.lnglat = [lng,lat];
    if (this.locationMarker != null) {
      this.map.remove(this.locationMarker)
    }
    this.locationMarker = new AMap.Marker({
      icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
      position: this.lnglat
    });
    this.propagateChange(this.lnglat);
    this.map.add(this.locationMarker);
    this.map.setFitView();
  }
}
